<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        <a href="#" @click.prevent="goBack"><i class="fa fa-angle-left"></i></a>
        Detalle Pallet (<span v-if="NumeroPallet">{{ NumeroPallet }})</span>
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div>
              <b-table striped hover small :fields="columns" :items="tableContentPallet">
                <template v-slot:cell(Ver)="data">
                  <a
                    target="_blank"
                    href="#"
                    title="Ver en detalle"
                    @click.prevent="seeDetailContent(data.item)"
                    class="fa fa-lg fa-arrow-right text-primary text-right"
                  ></a>
                </template>

                <template v-slot:cell(Variedad)="data"> {{ data.item.Variedad }} - {{ data.item.condicion }} </template>

                <template v-slot:cell(+)="data">
                  <p class="text-info" @click="data.toggleDetails">+</p>
                </template>

                <template v-slot:cell(fecha)="data">
                  {{ data.item.fecha | moment }}
                </template>

                <!--  <template v-slot:cell(Existe)="data">
          <b-badge pill :variant="getBadge(data.item.Existe)">{{data.item.Existe}}</b-badge>
        </template> -->

                <template v-slot:row-details="row">
                  <b-card class="">
                    <b-row class="mb-0">
                      <b-col sm="3" class="text-sm-right"><b>Producto:</b></b-col>
                      <b-col>{{ row.item.Producto }}</b-col>
                    </b-row>
                    <b-row class="mb-0">
                      <b-col sm="3" class="text-sm-right"><b>Tipo de Producto:</b></b-col>
                      <b-col>{{ row.item.Tipo_producto }}</b-col>
                    </b-row>
                    <b-row class="mb-0">
                      <b-col sm="3" class="text-sm-right"><b>KN:</b></b-col>
                      <b-col>{{ row.item.kilos_netos }}</b-col>
                    </b-row>
                  </b-card>
                </template>
              </b-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

Vue.use(ClientTable);

export default {
  name: "detaildedPallet",
  props: ["PalletID", "NumeroPallet"],
  components: {
    vSelect
  },
  created() {},
  data() {
    return {
      options: [],
      items: [],
      tableContentPallet: [],
      perPage: 5,
      currentPage: 1,
      columns: [
        // "Producto",
        // "Tipo_producto",
        "+",
        "Variedad",
        "Origen",
        {
          key: "planta",
          label: "Planta",
          formatter: (value, key, item) => {
            return value ? value.name : "-";
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        "planta",
        "fecha",

        // "kilos_netos",
        "formato",
        "Especificaciones",
        "Cantidad",
        // "Existe",
        "Ver"
      ]
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },

  methods: {
    loadContenPallet() {
      this.tableContentPallet = [];

      this.$axios
        .get("/api/v1/allstock/" + this.PalletID + "/get_all_content_pallet/")
        .then((res) => {
          const datos = res.data.data;

          for (let key in datos) {
            var rowNew = {
              Producto: datos[key].variety.product.name,
              Tipo_producto: datos[key].product_type.name,
              Variedad: datos[key].variety.name,
              Origen: datos[key].origin.name,
              kilos_brutos: datos[key].gross_kilograms,
              kilos_netos: datos[key].net_kilograms,
              Cantidad: datos[key].quantity,
              Especificaciones: datos[key].specifications,
              IDContenido: datos[key].id,
              formato: datos[key].container.name,
              condicion: datos[key].condition,
              fecha: datos[key].creation_date,
              planta: datos[key].plant,
              // Existe: datos[key].status_content== true ? "Si" : "No",
              pallet_number: datos[key].pallet_number
            };

            this.tableContentPallet.push(rowNew);
          }
        })
        .catch((error) => console.log(error.message));
    },
    getBadge(existe) {
      return existe === "Si" ? "success" : "danger";
    },
    seeDetailContent(row) {
      this.$router.push("/trazabilidad/detailed/" + this.PalletID + "/" + row.IDContenido + "/" + row.pallet_number);
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.tableContentPallet = [];
    this.loadContenPallet();
  }
};
</script>
